import React, { FC } from 'react';

import { IconProps } from '../../types/icon.types';

export const EditIcon: FC<IconProps> = ({
  width = 20,
  height = 20,
  stroke = '#111026',
  className,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 13.5L12.2426 4.25736C12.6331 3.86683 13.2663 3.86683 13.6568 4.25736L15.7426 6.34315C16.1332 6.73367 16.1332 7.36684 15.7426 7.75736L6.5 17H3V13.5Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M10.5 5.5L14.5 9.5" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};
